module.exports = __webpack_public_path__ + "img/payment-canceled.85e0c6fc.svg";